import * as types from "./loanPlanActionTypes";
import * as apiUrls from "./loanPlanApiUrls";

import { BaseApi } from "../shared/api";
import * as url from "./apiUrls";
import {
  startLoading,
  stopLoading,
  showErrors,
} from '../shared/actions';

import Cookies from "universal-cookie";

const cookies = new Cookies();

function receiveLoanPlan(loanPlan) {
  return { type: types.RECEIVE_LOAN_PLAN, payload: loanPlan };
}

export function updateLoanPlan(loanPlanId, data, callback = () => {}) {
  return (dispatch, getState) => {
    dispatch(startLoading());
    const { user, loan_plan } = getState();
    const api = new BaseApi(dispatch, getState);

    if (!user || !user.id || !loan_plan || !loan_plan.id) {
      dispatch(stopLoading());
      dispatch(showErrors({status: '', statusText: 'Unable to update Loan Plan'}));
      return;
    }

    return api.putRequest(
      url.userLoanPlan(user.id, loanPlanId),
      data,
      response => {
        dispatch(receiveLoanPlan(response.data));
        dispatch(stopLoading());
        callback();
      }
    )
  };
}


export function fetchLoanPlan(loanPlanId, callback = () => {}) {
  return (dispatch, getState) => {
    dispatch(startLoading());
    const user = getState().user;
    const api = new BaseApi(dispatch, getState);

    if (!user || !user.id) {
      dispatch(stopLoading());
      dispatch(showErrors({status: '', statusText: 'Unable to fetch Loan Plan'}));
      return;
    }

    return api.getRequest(
      url.userLoanPlan(user.id, loanPlanId),
      response => {
        dispatch(receiveLoanPlan(response.data));
        callback(response);
        dispatch(stopLoading());
      }
    )
  }
}

export function fetchLoanPlans(user_id) {
  return (dispatch) => {
    dispatch(startLoading());
    return fetch(apiUrls.apiV2UserLoanPlans(user_id), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then(json => {
      dispatch(stopLoading());
      return dispatch(receiveLoanPlans(json));
    })
    .catch(error => {
      dispatch(stopLoading());
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function receiveLoanPlans(json) {
  return {type: types.RECEIVE_LOAN_PLANS, payload: json};
}

export function fetchRepayments(user_id, loan_plan_id, callback = () => {}) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2UserLoanPlanRepayments(user_id, loan_plan_id), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken"),
      }),
    })
    .then(response => response.json())
    .then(json => {
      callback(json);
      return dispatch(receiveRepayments(json));
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  }
}

export function receiveRepayments(json) {
  return {type: types.RECEIVE_REPAYMENTS, payload: json};
}



// WEBPACK FOOTER //
// ./src/features/loans/loanPlanActions.js